import { useEffect, useState } from 'react';
import { useApp } from '@/contexts/AppContext';

// Cache: { 'cache_key|lang': string[] }
const memCache = {};

export function useTranslated(texts, cacheKey) {
  const { lang, api } = useApp();
  const [out, setOut] = useState(texts);
  useEffect(() => {
    if (!texts || !texts.length) { setOut(texts); return; }
    if (lang === 'en') { setOut(texts); return; }
    const ck = `${cacheKey}|${lang}`;
    if (memCache[ck]) { setOut(memCache[ck]); return; }
    let active = true;
    api.post('/translate', { texts, target: lang, cache_key: cacheKey }).then((r) => {
      if (!active) return;
      const arr = r.data?.translations || texts;
      memCache[ck] = arr;
      setOut(arr);
    }).catch(() => setOut(texts));
    return () => { active = false; };
  }, [texts.join('|'), lang, cacheKey, api]);
  return out;
}
